export default "__VITE_ASSET__D7Lm2US7__"